import type FormCCOtp from "@/interface/FormCCOtp";
import type { Ref } from "vue";
import { ref } from "vue";

export default function useFormOTP(): Ref<FormCCOtp> {
  return ref<FormCCOtp>({
    otpMobile: {
      pac: "",
      otp: Array(6).fill(""),
      status: "",
      number: 0,
      full: false,
      needValidate: true,
      resend: 0,
      success: false,
      validated: false,
    },
    otpEmail: {
      pac: "",
      otp: Array(6).fill(""),
      status: "",
      number: 0,
      full: false,
      needValidate: true,
      resend: 0,
      success: false,
      validated: false,
    },
    verified: "",
    populateUpdatedFlag: "false",
    principalStatus: "",
    supplementaryOtp: {
      pac: "",
      otp: Array(6).fill(""),
      status: "",
      number: 0,
      full: false,
      needValidate: true,
      resend: 0,
      success: false,
      validated: false,
    },
  });
}
